<template>
  <b-container fluid>
    <div class="pt-5 header">
      <img
        class="brand-icon pointer"
        src="../assets/smartz-logo.svg"
        @click="toDashboard()"
      />
      <b-navbar toggleable="sm">
        <b-nav class="nav-wrapper">
          <b-nav-item
            to="/"
            :active="activeIndex === '/'"
            v-if="
              p('Dashboard.Pod Accel.View') ||
                p('Dashboard.Pod Capacitance.View') ||
                p('Dashboard.Pod Data Stream.View')
            "
          >
            <img class="nav-icon mr-5" src="../assets/dashboard-default.svg" />
            {{ $t('text.dashboard') }}</b-nav-item
          >
          <b-nav-item
            to="/products"
            :active="activeIndex === '/products'"
            v-if="
              p('Products.Manufacturers.View') ||
                p('Products.Product Description.View') ||
                p('Products.Product Characteristics.View') ||
                p('Products.Run.View') ||
                p('Products.Analyse Runs.View')
            "
          >
            <img class="nav-icon w-20 mr-5" src="../assets/chart-default.svg" />
            {{ $t('text.products') }}</b-nav-item
          >
          <b-nav-item
            to="/pods"
            :active="activeIndex === '/pods'"
            v-if="
              p('Pods.Capacitance Readings Chart.View') ||
                p('Pods.Connection Status Chart.View') ||
                p('Pods.Battery Levels Chart.View') ||
                p('Pods.Accelerometer Readings Chart.View') ||
                p('Pods.Temperature Chart.View') ||
                p('Pods.SPO2 Chart.View') ||
                p('Pods.Calibration.View') ||
                p('Pods.Find Data.View') ||
                p('Pods.Diagnostics.View') ||
                p('Pods.Live Data.View')
            "
          >
            <img class="nav-icon w-12 mr-5" src="../assets/goal-default.svg" />
            {{ $t('text.pods') }}</b-nav-item
          >
          <b-nav-item
            to="/reports"
            :active="activeIndex === '/reports'"
            v-if="p('Reports.Export CSV.Export')"
          >
            <img
              class="nav-icon w-15 mr-5"
              src="../assets/report-default.svg"
            />
            {{ $t('text.reports') }}</b-nav-item
          >
          <b-nav-item
            to="/production"
            :active="activeIndex === '/production'"
            v-if="
              p('Production.Monitoring.View') ||
                p('Production.Test Reports.View') ||
                p('Production.Acceptance Criteria.View') ||
                p('Production.Firmware & Software.View')
            "
          >
            <img
              class="nav-icon w-15 mr-5"
              src="../assets/production-default.svg"
            />
            PRODUCTION</b-nav-item
          >
          <b-nav-item
            to="/manage"
            :active="activeIndex === '/manage'"
            v-if="
              p('Manage.Users.View') ||
                p('Manage.Roles.View') ||
                p('Manage.Distributors.View')
            "
          >
            <img
              class="nav-icon w-15 mr-5"
              src="../assets/manage-default.svg"
            />
            {{ $t('text.manage').toUpperCase() }}</b-nav-item
          >
          <b-nav-item
            to="/backtest"
            :active="activeIndex === '/backtest'"
            v-if="p('Developer.Back Test.View')"
          >
            <img class="nav-icon w-20 mr-5" src="../assets/chart-default.svg" />
            BACKTEST</b-nav-item
          >
          <b-nav-item
            to="/labelling-tool"
            :active="activeIndex === '/labelling-tool'"
            v-if="
              p('Data Entry.Labelling Tool.View') ||
                p('Data Entry.Labelling Tool.Audit') ||
                p('Data Entry.Labelling Tool.Test')
            "
          >
            <img class="nav-icon w-20 mr-5" src="../assets/chart-default.svg" />
            LABELLING TOOL</b-nav-item
          >
          <b-nav-item to="/lora" :active="activeIndex.startsWith('/lora')">
            <img
              class="nav-icon w-20 mr-5"
              src="../assets/dashboard-default.svg"
            />
            INSTALLATION TOOL</b-nav-item
          >
        </b-nav>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <!-- <LanguageBar /> -->
            <RegionSwitcher />
            <b-nav-item-dropdown class="user-dropdown" right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <span class="user-avatar">{{ UsernameInitial }}</span>
              </template>
              <b-dropdown-item
                v-if="Username"
                disabled
                class="user-dropdown-name"
              >
                {{ Username }}
              </b-dropdown-item>
              <b-dropdown-divider v-if="Username"></b-dropdown-divider>
              <b-dropdown-item
                @click="redirectTo('https://www.smartzhealth.com/faqs/')"
                >{{ $t('text.frequently_asked_questions') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://www.smartzhealth.com/user-manual/')"
                >{{ $t('text.information_for_use') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://smartzhealth.com/downloads/')"
                >{{ $t('text.data_privacy') }}</b-dropdown-item
              >
              <b-dropdown-item
                @click="redirectTo('https://smartzhealth.com/downloads/')"
                >{{ $t('text.eula') }}</b-dropdown-item
              >
              <b-dropdown-item v-b-modal.about>{{
                $t('text.about')
              }}</b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="logout">
                {{ $t('text.logout') }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <b-modal
      id="about"
      ref="about"
      centered
      :hide-header="true"
      :hide-footer="true"
    >
      <div class="white-bg">
        <img
          src="../assets/brand_logo_black.png"
          width="150px"
          class="mb-10 mt-30"
        />
        <div class="name mb-5">{{ $t('text.dashboard') }}</div>
        <div class="version mb-30">{{ $t('text.version') }} {{ version }}</div>
      </div>
      <div class="grey-bg">
        <div class="inline-block left-side">
          <div class="mb-40">{{ $t('text.copyright') }}.</div>
          <div class="mb-5">{{ $t('text.support').toUpperCase() }}</div>
          <div>customerservice@simavita.com</div>
        </div>
        <div class="inline-block right-float text-right">
          <img src="../assets/c1.svg" class="mr-10" />
          <img src="../assets/c2.svg" />
          <div class="close-btn">
            <b-button variant="outline-primary" @click="closeAboutModal()">{{
              $t('text.close')
            }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
// import LanguageBar from '@/components/LanguageBar.vue'
import RegionSwitcher from '@/components/RegionSwitcher.vue'

export default {
  data() {
    return {
      activeIndex: this.$route.path,
      version: ''
    }
  },
  components: {
    RegionSwitcher
  },
  mounted() {
    let app = require('../../package.json')
    this.version = app.version
  },
  methods: {
    toDashboard() {
      this.$router.push('/')
      this.$parent.$refs.content.type = 'pod_capacitance'
    },
    logout() {
      this.$store.dispatch('user/logout')
    },
    closeAboutModal() {
      this.$refs['about'].hide()
    },
    redirectTo(link) {
      window.open(link, '_blank')
    }
  },
  computed: {
    Username() {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user != null) {
        return user.username
      }
      return null
    },
    UsernameInitial() {
      const user = JSON.parse(localStorage.getItem('user'))
      return user && user.username ? user.username[0].toUpperCase() : '?'
    }
  }
}
</script>
